import { render, staticRenderFns } from "./ConversationNew.vue?vue&type=template&id=776d84d1&"
import script from "./ConversationNew.vue?vue&type=script&lang=js&"
export * from "./ConversationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports